import uuid from 'powtoon-commons/utils/uuid'
import {get, isEmpty, isNil, maxBy, omitBy} from 'lodash'
import {shallowEqual} from 'powtoon-commons/utils'

import {EMPTY_SLIDE, DEFAULT_SLIDE_DURATION, INTERACTION_LOCK, ContentSourceTypes} from '../consts'
import {isMasterTrackEmpty} from 'powtoon-commons/models/utils/masterObject'

export function isEmptySlide({background, tracks, masterTracks}) {
  
  const color = background.color && background.color.toLowerCase()
  const slideBackground = {...background, color}
  return shallowEqual(slideBackground, EMPTY_SLIDE.background) && isEmpty(tracks) && isMasterTrackEmpty(masterTracks)
}

export function createNewSlideId() {
  return uuid()
}

export const createNewSlide = (slide, {keepId = false} = {}, duration = DEFAULT_SLIDE_DURATION) => ({
  ...EMPTY_SLIDE,
  duration,
  ...omitBy(slide, isNil),
  id: keepId && slide.id ? slide.id : createNewSlideId()
})

export function resolveImagePreviewUrl(imageManifestItem, {minPreviewSize = 720} = {}) {
  const versions = get(imageManifestItem, ['imageData', 'versions'], {})
  const maxSize = maxBy(Object.keys(versions), key => parseInt(key))
  return (maxSize > minPreviewSize) ?
    get(versions, [maxSize, 'url'], imageManifestItem.previewUrl) :
    imageManifestItem.previewUrl
}

export const isInteractionLocked = ({interactionLock} = {}) => (
  interactionLock && interactionLock !== INTERACTION_LOCK.NONE
)

export const isAdminLocked = ({interactionLock}) => (
  interactionLock && interactionLock === INTERACTION_LOCK.ADMIN
)

export const isPowtoonFromAiSource = contentSource => (
  contentSource === ContentSourceTypes.Producer ||
  contentSource === ContentSourceTypes.TextToSpeechAI ||
  contentSource === ContentSourceTypes.ScriptWriter
)